// extracted by mini-css-extract-plugin
export default {"image":"sYBnB8"};